var _rect, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "url(#paint0_linear_1624_48564)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M4 9.66667C4 8.19391 5.23122 7 6.75 7H23.25C24.7688 7 26 8.19391 26 9.66667V20.3333C26 21.8061 24.7688 23 23.25 23H6.75C5.23122 23 4 21.8061 4 20.3333V9.66667ZM6.75 8.33333C5.99061 8.33333 5.375 8.93029 5.375 9.66667V9.95587L15 15.5559L24.625 9.95587V9.66667C24.625 8.93029 24.0094 8.33333 23.25 8.33333H6.75ZM24.625 11.5108L18.1514 15.2773L24.625 19.1403V11.5108ZM24.5786 20.6782L16.823 16.0501L15 17.1108L13.177 16.0501L5.42143 20.6782C5.57815 21.2474 6.11358 21.6667 6.75 21.6667H23.25C23.8864 21.6667 24.4219 21.2474 24.5786 20.6782ZM5.375 19.1403L11.8486 15.2773L5.375 11.5108V19.1403Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.6667C5 9.19391 6.23122 8 7.75 8H24.25C25.7688 8 27 9.19391 27 10.6667V21.3333C27 22.8061 25.7688 24 24.25 24H7.75C6.23122 24 5 22.8061 5 21.3333V10.6667ZM7.75 9.33333C6.99061 9.33333 6.375 9.93029 6.375 10.6667V10.9559L16 16.5559L25.625 10.9559V10.6667C25.625 9.93029 25.0094 9.33333 24.25 9.33333H7.75ZM25.625 12.5108L19.1514 16.2773L25.625 20.1403V12.5108ZM25.5786 21.6782L17.823 17.0501L16 18.1108L14.177 17.0501L6.42143 21.6782C6.57815 22.2474 7.11358 22.6667 7.75 22.6667H24.25C24.8864 22.6667 25.4219 22.2474 25.5786 21.6782ZM6.375 20.1403L12.8486 16.2773L6.375 12.5108V20.1403Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1624_48564",
    x1: 0,
    y1: 0,
    x2: 32.0449,
    y2: 0.0450633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A7C69"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGreen);
export default __webpack_public_path__ + "static/media/email_green.3ddf87e790568d9a0ce5bb4b2edbadcb.svg";
export { ForwardRef as ReactComponent };